import type { GridProps } from '@chakra-ui/react'
import { Grid } from '@chakra-ui/react'

export interface FormContentProps extends GridProps {}

export const FormContent = ({ children }: FormContentProps) => {
  return <Grid sx={{ w: '100%', gap: 4 }}>{children}</Grid>
}
